export default "/dist/files/etonnement-plein-stroke.58435f90848ba6e2179e05d242b8209c.svg";